// extracted by mini-css-extract-plugin
export default {"component":"error_component__tMPVG","fadeIn":"error_fadeIn__PS48I","desktop":"error_desktop__vx6T9","content-fade":"error_content-fade__ryrAM"};